<template>
    <form-dropdown
        v-if="!rechargeOptionsLoading"
        id="dropdown-amount"
        :value="value"
        :label="label"
        :placeholder="placeholder"
        :error="error"
        :settings="setting"
        @input="input"
    />
    <div v-else class="field">
        <div class="label">{{ label }}:</div>
        <div class="control control-loading">
            <basic-loader :center="true" aria-label="RechargeOptions" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import filters from '../../../vue/filters';

export default {
    props: {
        value: { type: Number, required: true },
        threshold: { type: Number, required: false, default: 0 },
        error: { type: String, required: false, default: null },
        label: { type: String, required: true },
        placeholder: { type: String, required: true },
        optionLabel: { type: String, required: false, default: 'message credits' },
    },

    emits: ['input'],

    computed: {
        ...mapState(stores.BillingSources, ['rechargeOptions', 'rechargeOptionsLoading']),

        creditsSet() {
            return this.rechargeOptions.filter(({ credits }) => credits > this.threshold);
        },

        selectedOption() {
            return this.rechargeOptions.find(({ credits }) => credits === +this.value);
        },

        setting() {
            return {
                maxItems: 1,
                dropdownParent: 'body',
                valueField: 'key',
                options: this.creditsSet.map((item) => ({
                    key: item.credits,
                    label: `${filters.currency(item.price * 100)} - ${item.credits} ${this.optionLabel}`,
                    value: item.credits,
                })),
                render: {
                    option: this.option,
                    item: this.item,
                },
            };
        },
    },

    methods: {
        input(value) {
            this.$emit('input', value, this.selectedOption);
        },
        option(item, escape) {
            return `<div class="threshold-${escape(item.value)}">
              ${escape(item.label)}
            </div>`;
        },
        item(item, escape) {
            return `<div>
                    ${escape(item.label)}
                </div>`;
        },
    },

    mounted() {
        this.$store.dispatch('getRechargeOptions');
    },
};
</script>

<style scoped>
.control-loading {
    height: 2.25em;
    display: flex;
    align-items: center;
}
</style>
